import { Box, HStack, Pressable, View } from '@rbilabs/universal-components';
import { Platform } from 'react-native';

import { ActionButtonVariants } from 'components/action-button';
import Link from 'components/link';
import { theme } from 'styles/configure-theme';

const headerIconPressedBg = theme.token('background-icon-header-contrast');

const headerIconContainerStyles = {
  zIndex: Styles.zIndex.overlay,
  _pressed: {
    backgroundColor: headerIconPressedBg,
  },
  _focus: {
    backgroundColor: headerIconPressedBg,
  },
  _hover: {
    backgroundColor: headerIconPressedBg,
    color: 'inherit',
  },
};

// The absolute position pops it out of the flex flow
// and this allows our centered logo to be truly centered and not offset by the menu item
export const MenuButtonContainer = Box.withConfig({
  position: 'absolute',
  zIndex: 1,
  left: '4',
  flexShrink: 1,
});

export const MobileHeaderContainer = Box.withConfig<{
  reversed?: boolean;
}>(p => ({
  safeAreaTop: true,
  paddingBottom: '0px',
  width: 'full',
  background: p.reversed
    ? theme.token('background-hero-reversed')
    : theme.token('background-hero-light'),
  zIndex: Styles.zIndex.overlay,
  _web: {
    shadow: '1',
  },
}));

export const Header = HStack.withConfig({
  alignItems: 'center',
  color: theme.token('text-reversed'),
  height: Styles.layout.navHeight.mobile,
  justifyContent: 'space-between',
  paddingX: '4',
  textAlign: 'center',
  width: 'full',
});

export const LinkNoDecoration = Link.withConfig({
  ...headerIconContainerStyles,
});

export const HeaderIconContainer = Pressable.withConfig({
  ...headerIconContainerStyles,
  padding: 1,
  borderRadius: 'full',
});

interface ILinkStylesProps {
  reversed: boolean;
  selected: boolean;
  active: boolean;
}

const getLinkStyles = ({ reversed, selected }: ILinkStylesProps) => ({
  color: selected
    ? Styles.color.navLinkColor.active
    : reversed
    ? theme.token('text-reversed')
    : theme.token('text-default'),

  _hover: {
    ...(selected && { color: Styles.color.navLinkColor.active, textDecoration: 'none' }),
  },
});

// TODO: BKPE-3: getLinkStyles can be removed. Also, there are some TODOs that could be removed.
export const StyledLinkExternal = Link.withConfig<ILinkStylesProps>(props => ({
  // TODO: RN - this should work when Link is the Link from UCL
  isExternal: true,
  fontSize: 'lg',
  marginLeft: '20px',

  ...(props.active && { color: Styles.color.navLinkColor.active }),
  ...getLinkStyles(props),

  // TODO: RN - Do we need this?
  // &:first-of-type {
  //   margin-left: 0;
  // }
}));

export const StyledLink = Link.withConfig<ILinkStylesProps>(props => ({
  fontSize: 'lg',
  marginLeft: '20px',

  ...(props.active && { color: Styles.color.navLinkColor.active }),
  ...getLinkStyles(props),

  // TODO: RN - Do we need this?
  // &:first-of-type {
  //   margin-left: 0;
  // }
}));

export const StyledCenterSpacer = Box.withConfig({
  flexGrow: 1,
  alignItems: 'flex-end',
  textAlign: 'center',
});

export const StyledRightSpacer = Box.withConfig({
  flex: 1,
  alignItems: 'flex-end',
  flexDirection: 'row',
  justifyContent: 'flex-end',
});

export const StyledLogo = View.withConfig({
  height: '50px',
  width: '50px',
  marginX: 'auto',
  marginBottom: Platform.select({
    android: '-3px',
    default: '0',
  }),
  padding: '$1.5',
});

export const TopServiceModeContainer = View.withConfig({
  shadow: '$1',
  zIndex: 1,
});

export default {
  buttonVariant: ActionButtonVariants.PRIMARY,
  linkVariant: ActionButtonVariants.INVERSE,
  linkVariantReversed: ActionButtonVariants.PRIMARY,
};
